import React, { useState } from "react";
import "../QuestionBankSubjects.css";
import "./GamificationSubjectCategories.css";
import subjectImg1 from "../../assets/images/battlesubject.jpg";
import subjectImg2 from "../../assets/images/battlesubject.jpg";
import subjectImg3 from "../../assets/images/battlesubject.jpg";
import imgCoin from "../../assets/images/coiin.png";

const subjectData = [
  {
    id: 1,
    title: "Current Affairs",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been simply dummy text of the printing and typ the. Lorem Ipsum is simply dummy text of the printing and type.",
    image: subjectImg1,
  },
  {
    id: 2,
    title: "Current Affairs",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been simply dummy text of the printing and typ the. Lorem Ipsum is simply dummy text of the printing and type.",
    image: subjectImg2,
  },
  {
    id: 3,
    title: "Current Affairs",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been simply dummy text of the printing and typ the. Lorem Ipsum is simply dummy text of the printing and type.",
    image: subjectImg3,
  },
];

const SubjectInfoCard = ({ subject }) => {
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);

  return (
    <article className="subject-info-card">
      <div className="subject-info-card__main">
        <div className="subject-info-card__image">
          <img src={subject.image} alt={`${subject.title} subject`} />
        </div>

        <div className="subject-info-card__content">
          <h3 className="subject-info-card__title">{subject.title}</h3>

          <div className="subject-info-card__descriptionWrap">
            <p className={`subject-info-card__description ${isDescriptionExpanded ? "is-expanded" : ""}`}>
              {subject.description}
            </p>

            <button
              type="button"
              className="subject-info-card__descriptionToggle"
              onClick={() => setIsDescriptionExpanded((current) => !current)}
              aria-label={
                isDescriptionExpanded
                  ? `Show less description for ${subject.title}`
                  : `Show more description for ${subject.title}`
              }
            >
              {isDescriptionExpanded ? "Show less" : "Show more"}
            </button>
          </div>
        </div>
      </div>

      <div className="game-card-content">
        <div className="game-reward">
          <img className="imgCoin" src={imgCoin} alt="" />
          <span>25 Coins</span>
        </div>

        <button className="game-start-btn" type="button">
          <span>Start</span>
          <i className="bi bi-play-circle-fill"></i>
        </button>
      </div>
    </article>
  );
};

const GamificationSubjectCard = () => {
  return (
    <section className="subject-info-section" aria-label="Subject information">
      <div className="subject-info-grid">
        {subjectData.map((subject) => (
          <SubjectInfoCard key={subject.id} subject={subject} />
        ))}
      </div>
    </section>
  );
};

export default GamificationSubjectCard;
